import { useAtomValue } from "../app-jotai";
import { whiteboardsLoadingAtom, whiteboardSwitchingAtom } from "../app-jotai";

export const WhiteboardsLoadingOverlay = () => {
  const isLoadingList = useAtomValue(whiteboardsLoadingAtom);
  const isSwitching = useAtomValue(whiteboardSwitchingAtom);

  const isLoading = isLoadingList || isSwitching;

  if (!isLoading) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.3)",
        backdropFilter: isSwitching ? "blur(2px)" : "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20000,
      }}
    >
      {isSwitching ? (
        <div
          style={{
            display: "inline-block",
            width: "60px",
            height: "60px",
            border: "5px solid rgba(255, 255, 255, 0.3)",
            borderTop: "5px solid rgba(255, 255, 255, 0.95)",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
      ) : (
        <div
          style={{
            background: "rgba(255, 255, 255, 0.95)",
            padding: "2.5rem",
            borderRadius: "12px",
            textAlign: "center",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
            minWidth: "300px",
          }}
        >
          <div
            style={{
              display: "inline-block",
              width: "40px",
              height: "40px",
              border: "4px solid #e0e0e0",
              borderTop: "4px solid #1a1a1a",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              marginBottom: "1rem",
            }}
          />
          <h2
            style={{
              margin: "0 0 0.5rem 0",
              fontSize: "1.25rem",
              fontWeight: 600,
              color: "#1a1a1a",
            }}
          >
            Loading Whiteboards
          </h2>
          <p
            style={{
              margin: "0",
              fontSize: "0.95rem",
              color: "#666",
            }}
          >
            Please wait while your whiteboards are loading from the server...
          </p>
        </div>
      )}
      <style>{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};
